module.exports = __webpack_public_path__ + "3block.png?32460216478000febc4ac4a1b3aafacb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3block.png
// module id = 378
// module chunks = 0